module.exports = __webpack_public_path__ + "img/Care2.cd31312a.png";